import { CanHistoryMessages, TranslationCanHistoryMessages } from "../interfaces/canHistoryMessages";

export const canHistoryMessages: TranslationCanHistoryMessages = {
  [CanHistoryMessages.title]: "CAN History",
  [CanHistoryMessages.dateTime]: "Date/Time",
  [CanHistoryMessages.fleet]: "Fleet",
  [CanHistoryMessages.plate]: "Plate",
  [CanHistoryMessages.travelDoc]: "Invoice",
  [CanHistoryMessages.status]: "Status",
  [CanHistoryMessages.driver]: "Driver",
  [CanHistoryMessages.ignition]: "Ignition",
  [CanHistoryMessages.ignitionOn]: "On",
  [CanHistoryMessages.ignitionOff]: "Off",
  [CanHistoryMessages.odometer]: "Odometer",
  [CanHistoryMessages.totalFuel]: "Total Fuel",
  [CanHistoryMessages.speed]: "Speed",
  [CanHistoryMessages.rpm]: "RPM",
  [CanHistoryMessages.coolantTemp]: "Coolant Temp.",
  [CanHistoryMessages.fuelConsumption]: "Fuel Consumption",
  [CanHistoryMessages.fuelLevel]: "Fuel Level",
  [CanHistoryMessages.hourmeter]: "Hourmeter",
  [CanHistoryMessages.totalDrivingTime]: "Total Driving Time",
  [CanHistoryMessages.idleFuel]: "Idle Fuel Consumption",
  [CanHistoryMessages.address]: "Address",
  [CanHistoryMessages.rawDataTooltip]: "Raw tracker data (no CAN normalization)"
};

export const messages = canHistoryMessages;
